import React, { MouseEvent, Fragment } from 'react';
// Material ui
import {
    Grid,
    IconButton
} from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import CardItem from '@/src/components/UI-KIT/CardItem';
import Carousel from '@components/UI-KIT/Carousel';
import AmountFormat from '@components/utils/AmountFormat';
import Spinner from '@components/UI-KIT/Spinner';

// Services
import { Account } from '@services/account';

// Icons
import {
    BankOutlined,
    POLOutlined,
    CashOutlined,
    ContextMenu,
    BigStar
} from '@/assets/icons';

// Styles
import './MyAccountsSection.scss';
import VARIABLES from '@/assets/variables';

interface Props {
    accounts: Account[];
    accountStatus: 'pending' | 'ready';
    setMenu: React.Dispatch<React.SetStateAction<{
        account: Account;
        anchorEl: HTMLButtonElement;
    }>>;
}

const MyAccountsSection: React.FC<Props> = ({
    accounts,
    accountStatus,
    setMenu
}) => {

    const handleIcon = (account: Account) => {
        switch (account.type) {
            case 'Cash':
                return (
                    <CashOutlined
                        width={32}
                        height={32}
                    />
                );
            case 'Bank':
                return (
                    <BankOutlined
                        width={32}
                        height={32}
                    />
                );
            case 'POL':
                return (
                    <POLOutlined
                        width={32}
                        height={32}
                    />
                );
        }
    };

    return (
        <>
            <Grid
                className="AOL-Accounts-section-container"
            >
                <Typography
                    variant="h3"
                    color="secondary"
                    className="AOL-accounts-pagination-title"
                >
                    Cuentas
                </Typography>
                { accountStatus === 'ready' && (
                    <Carousel>
                        {accounts.map((account: Account) => (
                            <Fragment
                                key={`account-${account.name}`}
                            >
                                <CardItem>
                                    <Grid
                                        container
                                        justify="flex-start"
                                        wrap="nowrap"
                                        alignItems="center"
                                    >
                                        <Grid
                                            className="ui-Card-item-icon-container"
                                        >
                                            { handleIcon(account) }
                                        </Grid>
                                        <Typography
                                            variant="h4"
                                            color="primary-dark"
                                        >
                                            {account.name}
                                        </Typography>
                                        {account.isDefault && (
                                            <Grid
                                                item
                                            >
                                                <BigStar
                                                    className="AOL-tenants-profile-banks-card-star"
                                                    color={VARIABLES.palette.secondary_color}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                    <Typography
                                        variant="h2"
                                        color="primary-dark"
                                    >
                                        <AmountFormat
                                            value={account.amount}
                                        />
                                    </Typography>
                                    <Grid
                                        item
                                        container
                                        xs={2}
                                        justify="flex-end"
                                        wrap="nowrap"
                                        alignItems="center"
                                    >
                                        { ![ 'POL', 'Credit Note' ].includes(account.type) && (
                                            <IconButton
                                                disableRipple
                                                key={`id-menu-${account.name}`}
                                                onClick={({ currentTarget: anchorEl }: MouseEvent<HTMLButtonElement>) => {
                                                    setMenu({ account, anchorEl });
                                                }}
                                            >
                                                <ContextMenu
                                                    key={`icon-${account.name}`}
                                                    color={VARIABLES.palette.secondary_color}
                                                />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </CardItem>
                            </Fragment>
                        ))}
                    </Carousel>
                )}
                { accountStatus === 'pending' && (
                    <Spinner />
                )}
            </Grid>
        </>
    );
};

export default React.memo(MyAccountsSection);